import React from "react";
import CreateSprint from "./CreateSprint";
import QuoteButton from "./QuoteButton";

function Section({ title, onAdd, colourBlindMode }) {
    return (
        <div class="relative flex items-center h-24 max-sm: justify-between bg-[#9b9b9b] z-[1] mt-[70px]">
            {/* section Title */}
            <div class="text-white font-sans text-3xl ml-[385px] whitespace-nowrap">
                <span>{title}</span>
            </div>
            <div class="flex">
                <QuoteButton colourBlindMode={colourBlindMode}/>
                <CreateSprint onAdd={onAdd} />
            </div>
        </div>
    );
}

export default Section;
